// src/components/Footer.jsx

const YT_SVG  = <svg width="16" height="16" viewBox="0 0 24 24" fill="#ff3333"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>;
const X_SVG   = <svg width="16" height="16" viewBox="0 0 24 24" fill="var(--text2)"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/></svg>;
const IG_SVG  = <svg width="16" height="16" viewBox="0 0 24 24" fill="url(#ig-footer)"><defs><linearGradient id="ig-footer" x1="0%" y1="100%" x2="100%" y2="0%"><stop offset="0%" stopColor="#f09433"/><stop offset="25%" stopColor="#e6683c"/><stop offset="50%" stopColor="#dc2743"/><stop offset="75%" stopColor="#cc2366"/><stop offset="100%" stopColor="#bc1888"/></linearGradient></defs><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>;

export default function Footer() {
  return (
    <footer className="toa-footer">
      <div className="toa-foot">
        <div className="toa-ftop">
          <div>
            <div className="toa-fbn">The Ones Above</div>
            <div className="toa-fbs">"Rise Above. Grow Together."</div>
            <p className="toa-fbd">
              A community built on brotherhood, creed, and the relentless pursuit of growth. Join us in
              Minecraft, Discord, and beyond. Est. 2024.
            </p>
          </div>
          {[
            { title: "Community", links: ["Discord Server", "Forum & Threads", "Leaderboards", "Events"] },
            { title: "Minecraft",  links: ["Server Info", "TOA Coins", "MC Store", "Updates"] },
            { title: "About",      links: ["Our Story", "TOA Merch", "TOA Hub", "Contact"] },
          ].map(({ title, links }) => (
            <div key={title}>
              <div className="toa-fct">{title}</div>
              <ul className="toa-flinks">
                {links.map(l => <li key={l}><a href="#">{l}</a></li>)}
              </ul>
            </div>
          ))}
        </div>

        <div className="toa-fbot">
          <div className="toa-fcopy">
            © 2025 <span>The Ones Above</span> · All rights reserved · <span>theonesabove.org</span>
          </div>
          <div className="toa-fsoc">
            <a href="https://www.youtube.com/@TheOnesAboveMedia"  target="_blank" rel="noreferrer" className="toa-fsb" title="YouTube">{YT_SVG}</a>
            <a href="https://x.com/"         target="_blank" rel="noreferrer" className="toa-fsb" title="X (Twitter)">{X_SVG}</a>
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="toa-fsb" title="Instagram">{IG_SVG}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
